import BaseClient from './BaseClient';

class ConnectionsClient extends BaseClient {
    generateConnectionKey(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/connection-keys`, 'post');
    }
}

export default new ConnectionsClient();
